import React from 'react';
import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';

import { getStatusColor } from '~/renderer/components/ConnectionStatus/helpers';

import type { ConnectionStatusType } from '~/renderer/store/connection/types';

interface Props {
  status: ConnectionStatusType;
}

const pulse = (status: ConnectionStatusType) => keyframes`
  0% {
    box-shadow: 0 0 0 0 ${getStatusColor(status)}40;
  }
  70% {
    box-shadow: 0 0 0 10px ${getStatusColor(status)}00;
  }
  100% {
    box-shadow: 0 0 0 0 ${getStatusColor(status)}00;
  }
`;

const StatusIndicator = styled('div')<Props>`
  height: 10px;
  width: 10px;
  border-radius: 100%;
  background-color: ${({ status }) => getStatusColor(status)};
  box-shadow: 0 0 0 ${({ status }) => getStatusColor(status)}40;
  animation: ${({ status }) => pulse(status)} 2s infinite;
  transition: all 0.3s ease-in-out;
`;

const Indicator: React.FC<Props> = props => <StatusIndicator {...props} />;

export default Indicator;
